var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-app-bar",
        { attrs: { flat: "", color: "primary", role: "navigation" } },
        [
          _c("v-toolbar-title", { staticClass: "text-body-2" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("components.downloads.title")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            attrs: {
              color: "accent",
              indeterminate: "",
              role: "progressbar",
              "aria-label": "Loading download items",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        _vm._l(_vm.games, function (game) {
          var _obj
          return _c(
            "v-flex",
            _vm._b(
              {
                key: game.id,
                attrs: {
                  "aria-labelledby": "game-title-" + game.id,
                  role: "region",
                  height: "150px",
                },
              },
              "v-flex",
              ((_obj = {}),
              (_obj[
                "xs" +
                  game.flexExtraSmall +
                  " sm" +
                  game.flexSmall +
                  " md" +
                  game.flexMedium +
                  " lg" +
                  game.flexLarge
              ] = true),
              _obj),
              false
            ),
            [
              game.isActive
                ? _c(
                    "v-card",
                    { attrs: { outlined: "" } },
                    [
                      _c("v-img", {
                        attrs: {
                          alt: _vm.$t(game.title) + " preview image",
                          src: game.img,
                          height: "80px",
                          role: "img",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "v-list-item-download-labels downloadCards",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          game.isNew
                            ? _c(
                                "span",
                                { staticClass: "downloadLabel downloadNew" },
                                [_vm._v("New")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          game.isRecommend
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "downloadLabel downloadRecommend",
                                },
                                [_vm._v("Recommend")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          game.isRecommend
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "downloadLabel downloadComingSoon",
                                },
                                [_vm._v("Coming Soon")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-title", { attrs: { "primary-title": "" } }, [
                        _c("div", [
                          _c(
                            "h3",
                            {
                              staticClass: "h5",
                              attrs: { id: "game-title-" + game.id },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(game.title)) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "grey--text text-subtitle-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(game.subtitle)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label":
                                  _vm.$t(
                                    "components.downloads.buttons.download"
                                  ) +
                                  " " +
                                  _vm.$t(game.title),
                                text: "",
                                color: "accent",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.viewGameCard(game.link)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.downloads.buttons.download"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label":
                                  (_vm.isCardVisible(game.id)
                                    ? "Hide"
                                    : "Show") +
                                  " description of " +
                                  _vm.$t(game.title),
                                icon: "",
                                color: _vm.isCardVisible(game.id)
                                  ? "accent"
                                  : "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleGameCard(game.id)
                                },
                              },
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.isCardVisible(game.id)
                                        ? "keyboard_arrow_down"
                                        : "keyboard_arrow_up"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-slide-y-transition",
                        [
                          _c(
                            "v-card-text",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isCardVisible(game.id),
                                  expression: "isCardVisible(game.id)",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t(game.brief)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }